import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    CommandDialog,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    CommandSeparator,
} from "../ui/command";
import { DialogTitle } from "../ui/dialog";
import {
    Globe,
    Server,
    Mail,
    ShoppingBag,
    Languages,
    Home,
    Search as SearchIcon,
    FileText,
    Activity,
} from "lucide-react";

export const CommandPalette = ({ open, onOpenChange, onCartOpen }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const onKey = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();
                onOpenChange(!open);
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onOpenChange]);

    const run = (fn) => {
        onOpenChange(false);
        setTimeout(fn, 50);
    };

    return (
        <CommandDialog
            open={open}
            onOpenChange={onOpenChange}
            data-testid="command-palette"
        >
            <DialogTitle className="sr-only">
                {t("command.placeholder")}
            </DialogTitle>
            <CommandInput
                placeholder={t("command.placeholder")}
                data-testid="command-palette-input"
            />
            <CommandList>
                <CommandEmpty>{t("command.empty")}</CommandEmpty>
                <CommandGroup heading={t("command.navigation")}>
                    <CommandItem
                        onSelect={() => run(() => navigate("/preview"))}
                        data-testid="command-go-preview"
                    >
                        <Home className="me-2 h-4 w-4" />
                        Preview
                    </CommandItem>
                    <CommandItem
                        onSelect={() => run(() => navigate("/home-a"))}
                    >
                        <Home className="me-2 h-4 w-4" />
                        Direction A · Home
                    </CommandItem>
                    <CommandItem
                        onSelect={() => run(() => navigate("/style-guide"))}
                    >
                        <FileText className="me-2 h-4 w-4" />
                        Style guide
                    </CommandItem>
                    <CommandItem
                        onSelect={() => run(() => navigate("/login"))}
                    >
                        <Activity className="me-2 h-4 w-4" />
                        Sign in
                    </CommandItem>
                </CommandGroup>
                <CommandSeparator />
                <CommandGroup heading={t("command.services")}>
                    <CommandItem
                        onSelect={() =>
                            run(() => navigate("/home-a#services"))
                        }
                    >
                        <Globe className="me-2 h-4 w-4" />
                        {t("nav.domains")}
                    </CommandItem>
                    <CommandItem
                        onSelect={() => run(() => navigate("/home-a#dns"))}
                    >
                        <Server className="me-2 h-4 w-4" />
                        {t("nav.dns")}
                    </CommandItem>
                    <CommandItem
                        onSelect={() =>
                            run(() => navigate("/home-a#services"))
                        }
                    >
                        <Mail className="me-2 h-4 w-4" />
                        {t("nav.email")}
                    </CommandItem>
                </CommandGroup>
                <CommandSeparator />
                <CommandGroup heading={t("command.actions")}>
                    <CommandItem
                        onSelect={() =>
                            run(() => {
                                navigate("/home-a");
                                setTimeout(() => {
                                    const el =
                                        document.getElementById("hero-search");
                                    el?.querySelector("input")?.focus();
                                }, 350);
                            })
                        }
                    >
                        <SearchIcon className="me-2 h-4 w-4" />
                        {t("command.searchDomain")}
                    </CommandItem>
                    <CommandItem
                        onSelect={() => run(() => onCartOpen && onCartOpen())}
                    >
                        <ShoppingBag className="me-2 h-4 w-4" />
                        {t("command.openCart")}
                    </CommandItem>
                    <CommandItem
                        onSelect={() =>
                            run(() =>
                                i18n.changeLanguage(
                                    i18n.language === "ar" ? "en" : "ar",
                                ),
                            )
                        }
                    >
                        <Languages className="me-2 h-4 w-4" />
                        {t("command.switchLang")}
                    </CommandItem>
                </CommandGroup>
            </CommandList>
        </CommandDialog>
    );
};
